import React from 'react'
import { change, show, store, getEvents, update, success as changeSuccess, error as setError } from '../../../store/actions/webhooks.action'
import { Dialog, FormControlLabel, Radio, RadioGroup, TextField, AppBar, Toolbar, IconButton, Typography, Button, List, ListItem, ListItemText, Divider, InputAdornment, CircularProgress, FormControl, FormLabel, Chip } from '@material-ui/core'
import { JSONEditor } from '@json-editor/json-editor'
import { FaSave } from 'react-icons/fa'
import { BsPlusCircleFill } from "react-icons/bs"
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen } from '../../../store/actions/navigation.action'
import { MdClose, MdKeyboardBackspace } from 'react-icons/md'

export default function WebhookEdit(props) {
    
    const dispatch = useDispatch()
    const { events, variables, webhook, error } = useSelector(state => state.webhookReducer)
    const id = (props.uid) ? props.uid : null

    const [isLoading, setLoading] = React.useState(true)
    const [isOpen, setOpen] = React.useState(false)

    React.useEffect(() => {
        window.JSONEditor = new JSONEditor(document.getElementById('editor_holder'), {
            iconlib: 'fontawesome5',
            object_layout: 'normal',
            schema: {},
            show_errors: 'interaction',
            theme: 'bootstrap5'
        })

        window.JSONEditor.on('change',() => {
            dispatch(change({ body: window.JSONEditor.getValue()}))
            if (error.body && delete error.body);
            dispatch(setError(error))
        });
        return () => {
            window.JSONEditor = null
        }
    }, [])

    React.useEffect(() => {
        if (id) {
            dispatch(show(id)).then(res  => {
                setLoading(false)
                if(res.webhook) {
                    window.JSONEditor.setValue(res.webhook.body)
                }
            })
        } else {
            dispatch(getEvents()).then(()  => {
                dispatch(change({method: 'GET'}))
                setLoading(false)
            })
        }
        return () => {
            dispatch(change('clear'))
            dispatch(setError({}))
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _save = () => {
        if(id) {
            dispatch(update(id, webhook))
        } else {
            dispatch(store(webhook))
        }
    }

    const _setValue = (v) => {
        let el = document.getElementById('box-var')
        let id = el.getAttribute("data")
        let uid = el.getAttribute("data-id")
        let start = el.getAttribute("start-pos")
        let end = el.getAttribute("end-pos")
        let path = id.replaceAll("[", ".").replaceAll("]", "")
        let editor = window.JSONEditor.getEditor(path)
        let value = editor.getValue()
        
        if(start && end) {
            if(id === uid) {
                editor.setValue(value.substring(0, start) + v + value.substring(end, value.length))
            }else {
                editor.setValue(value + v)
            }
        }else {
            editor.setValue(value + v)
        }
        _close();
    }

    const _close = () => {
        document.getElementById('box-var').classList.add('d-none');
        document.body.style.overflow = 'inherit'
        document.body.style.paddingRight = 'inherit'
    }

    return (
        <>
            <div className="app-bar">
                <AppBar position="fixed">
                    <Toolbar>
                        <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                            <MdKeyboardBackspace />
                        </IconButton>
                        <Typography variant="h6">
                            {(id) ? 'Editar Webhook' : 'Novo Webhook'}
                        </Typography>

                        <Button onClick={() => _save() } color="inherit" className="ms-auto">
                            <FaSave className="me-2" /> Salvar
                        </Button>
                    </Toolbar>
                </AppBar>
                
                {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <Dialog
                        open={isOpen}
                        maxWidth="sm"
                        style={{width: '100%'}}
                        onClose={() => setOpen(false)}
                        className="center" 
                    >   
                        <div className="card card-body bs-bg">
                            <label className="fw-bold label-custom bs-color-b">METHOD</label>
                            <div className="mt-3 mb-3">
                                <RadioGroup
                                    name="type"
                                    value={webhook.method}
                                    onChange={e => {
                                        dispatch(change({ method: e.target.value }))
                                        setOpen(false)
                                    }}
                                    className="fw-normal bs-color-b"
                                >
                                    <FormControlLabel value="GET" control={<Radio color="primary" />} label="GET" />
                                    <FormControlLabel value="POST" control={<Radio color="primary" />} label="POST" />
                                    <FormControlLabel value="PUT" control={<Radio color="primary" />} label="PUT" />
                                    <FormControlLabel value="DELETE" control={<Radio color="primary" />} label="DELETE" />
                                </RadioGroup>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog
                        open={true}
                        maxWidth="sm"
                        style={{width: '100%'}}
                        onClose={() => _close()}
                        TransitionProps={{onEntered: () => {
                            document.body.style.overflow = 'inherit'
                            document.body.style.paddingRight = 'inherit'
                        }}}
                        className="d-none"
                        id="box-var"
                    >
                        <div className="d-flex align-items-center justify-content-between ps-3 bs-bg">
                            <Typography className="bs-color" variant="h6">Variáveis de ambiente</Typography>
                            <IconButton className="bs-color" aria-label="close" onClick={() => _close()}>
                                <MdClose />
                            </IconButton>
                        </div>

                        <div className="card card-body bs-bg rounded-0">
                            <Divider />

                            <label className="label-custom bs-color-b">User</label>
                            <List>
                                {variables.user.map((item, index) => (
                                    <Chip key={index} className="m-1 mb-2 chip" onClick={() => _setValue('{{user.'+item+'}}')} label={item} />
                                ))}
                            </List>

                            <label className="label-custom bs-color-b">Order</label>
                            <List>
                                {variables.order.map((item, index) => (
                                    <Chip key={index} className="m-1 mb-2 chip" onClick={() => _setValue('{{order.'+item+'}}')} label={item} />
                                ))}
                            </List>

                            <label className="label-custom bs-color-b">Product</label>
                            <List>
                                {variables.product.map((item, index) => (
                                    <Chip key={index} className="m-1 mb-2 chip" onClick={() => _setValue('{{product.'+item+'}}')} label={item} />
                                ))}
                            </List>

                            <label className="label-custom bs-color-b">Params</label>
                            <List>
                                {variables.params.map((item, index) => (
                                    <Chip key={index} className="m-1 mb-2 chip" onClick={() => _setValue('{{params.'+item+'}}')} label={item} />
                                ))}
                            </List>
                        </div>
                    </Dialog>

                    <div className="card mb-2 bs-bg">
                        <div className="card-body">
                            <label className="label-custom mb-3 bs-color-b">EVENTO</label>
                            <div className="mb-3">
                                <FormControl component="fieldset">
                                    <RadioGroup 
                                        aria-label="webhook_event" 
                                        name="webhook_event" 
                                        value={webhook.event || ''} 
                                        onChange={ e => {
                                            dispatch(change({ event: parseInt(e.target.value) }))
                                            if (error.event && delete error.event);
                                        }}
                                        className="fw-normal bs-color-b"
                                    >
                                        {events.map((item, index) => (
                                            <FormControlLabel key={index} value={item.id} control={<Radio color="primary" />} label={item.title} />
                                        ))}
                                    </RadioGroup>
                                </FormControl>

                                {(error.event) &&
                                    <strong className="text-danger d-block">{error.event[0]}</strong>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="card mb-2 bs-bg">
                        <div className="card-body">
                            <label className="label-custom mb-3 bs-color-b">TÍTULO</label>
                            <div className="mb-3">
                                <TextField
                                    value={webhook.title || ''}
                                    placeholder="Titulo"
                                    onChange={e => {
                                        dispatch(change({ title: e.target.value }))
                                        if (error.title && delete error.title);
                                    }}
                                />

                                {(error.title) &&
                                    <strong className="text-danger">{error.title[0]}</strong>
                                }
                            </div>
                        </div>
                    </div>
                    
                    <div className="card mb-2 bs-bg">
                        <div className="card-body">
                            <div className="d-flex align-items-center mb-3">
                                <label className="label-custom m-0 bs-color-b">REQUEST</label>
                                {webhook.method &&
                                    <button onClick={() => setOpen(true)} data={webhook.method} className="fw-bold btn-method ms-3">{webhook.method}</button>
                                }
                            </div>
                            
                            <div className="mb-3">
                                <TextField
                                    value={webhook.url || ''}
                                    placeholder="https://"
                                    onChange={e => {
                                        dispatch(change({ url: e.target.value }))
                                        if (error.url && delete error.url);
                                    }}
                                />

                                {(error.url) &&
                                    <strong className="text-danger">{error.url[0]}</strong>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="card mb-2 bs-bg">
                        <div className="card-body">
                            <label className="label-custom mb-3 bs-color-b">HEADERS</label>
                            {webhook.bearer_token &&
                                <div className="mb-3">
                                    <div className="row">
                                        <div className="col-6">
                                            <TextField
                                                disabled
                                                value="Authorization"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <TextField
                                                disabled
                                                value={"Bearer "+webhook.bearer_token}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            {webhook.headers_data.length > 0 &&
                                <>
                                {webhook.headers_data.map((item, index) => (
                                    <div className="mb-3" key={index}>
                                        <div className="row">
                                            <div className="col-6">
                                                <TextField
                                                    value={Object.keys(item)[0] || ''}
                                                    placeholder="Key"
                                                    onChange={e => {
                                                        let t = Object.fromEntries(
                                                            Object.entries(item).map(() =>
                                                                [e.target.value, Object.values(item)[0]]
                                                            )
                                                        )
                                                        webhook.headers_data[index] = t
                                                        dispatch(change({ headers_data: webhook.headers_data }))
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <TextField
                                                    value={Object.values(item)[0] || ''}
                                                    placeholder="Value"
                                                    onChange={e => {
                                                        let t = Object.fromEntries(
                                                            Object.entries(item).map(() =>
                                                                [Object.keys(item)[0], e.target.value]
                                                            )
                                                        )
                                                        webhook.headers_data[index] = t
                                                        dispatch(change({ headers_data: webhook.headers_data }))
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                </>
                            }
                            <div className="mb-3">
                                <IconButton 
                                    onClick={() => {
                                        if(webhook.headers_data.length < 4) {
                                            dispatch(change({
                                                headers_data: [
                                                    ...webhook.headers_data,
                                                    {'' : ''}
                                                ]
                                            }))
                                        }
                                    }}
                                    edge="start" 
                                    color="inherit"
                                >
                                    <BsPlusCircleFill className="me-3" color="#007bff" size={30} />
                                </IconButton>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-2 bs-bg">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <label className="label-custom m-0 bs-color-b">AUTH</label>
                                <label className="label-custom m-0 bs-color-b">Bearer Token</label>
                            </div>
                            
                            <div className="mb-3">
                                <TextField
                                    value={webhook.bearer_token || ''}
                                    placeholder="Token"
                                    onChange={e => dispatch(change({ bearer_token: e.target.value }))}
                                />
                            </div>
                        </div>
                    </div>
                    </>
                }

                <div className={"card mb-2 bs-bg "+ (isLoading ? 'invisible' : 'visible')}>
                    <div className="card-body">
                        <label className="label-custom mb-3 bs-color-b">BODY</label>
                        <div id="editor_holder"></div>

                        {(error.body) &&
                            <strong className="text-danger">{error.body[0]}</strong>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}